const Theme = {
  colors: {
    primary: "#0ba3a6",
    secondary: "#daf5f1",
  },
};

export default Theme;
